import React from 'react';
import VisionComponent from "../../Components/VisionPage/Vision.component";
import Navbar from '../../Components/Navbar/Navbar';
import Footer from '../../Components/Footer/Footer';
import "./visionpage.css";

function VisionPage() {
    return(
      <> 
         <Navbar />
         <VisionComponent />
         <Footer />
      </> 
    )
}
   
   
export default VisionPage;
